<script>
import { mapGetters } from "vuex";
import Notifcation from "./Notification.vue";
import ErrorNotification from "./ErrorNotification.vue";
export default {
  components: { ErrorNotification, Notifcation },
  computed: {
    ...mapGetters({
      errors: "errors",
      notifications: "notification",
    }),
  },
};
</script>

<template>
  <div class="notification-wrapper">
    <!--Notification component handle frontend messages. This take argument from notification mapGetter, which can be set by calling setNotification in mutation.type.js-->
    <Notifcation
      v-for="(notification, index) in notifications"
      :key="index"
      :notification="notification"
    />

    <!--ErrorNotification component handle error from backend. This takes argument from error mapGetter, which is updated by error-handler.js-->
    <ErrorNotification
      v-for="(error, index) in errors"
      :key="index"
      :title="error.title"
      :sub-title="error.subTitle"
      :caption="error.caption"
    />
  </div>
</template>

<style scoped>
.notification-wrapper {
  height: calc(100% - 4rem) !important;
  width: 100%;
  position: fixed;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 100;
}
</style>
